export default function stripHtmlTags(str) {
  if (str === null || str === "") {
    return str;
  } else {
    str = str.toString();
  }

  return str.replace(/<[^>]*>/g, "");
}
